import { apm } from "@elastic/apm-rum";
import { Person } from "@mui/icons-material";
import { Avatar, IconButton, Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import ClientConfig from "shared/config";
import { ProviderType } from "shared/common/provider/pilegateprovider";
import { monitor } from "shared/common/services/apm-logging";
import { defaultStore } from "shared/common/stores/defaultStore";
import { topbarStore } from "shared/common/stores/topbarStore";
import UserMenu from "./UserMenu";

interface props {
  role?: string;
}

export default function User({ role }: props) {
  //All about Language (i18n)
  const { t } = useTranslation();

  const viewer = defaultStore((state) => state.viewer);
  const changeAnchorUser = topbarStore((state) => state.changeAnchorUser);
  const anchorUser = topbarStore((state) => state.anchorUser);

  const [pointTo, setPointTo] = useState<string>();

  // Avatar Button Event Handler
  const handleUserMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    changeAnchorUser(event.currentTarget);
  };
  const handleUserClose = () => {
    changeAnchorUser(null);
  };

  //redirect to classic
  const redirectToClassic = () => {
    if (viewer === undefined) return "#";
    let url = "";
    const currentGeoframeKey = viewer.getScene().getCurrentGeoframe()?.key;
    const projectUIDParam = new URL(window.location.href).searchParams.get(
      "projectUID"
    );
    if (currentGeoframeKey) {
      const imageKey = window.btoa(encodeURI(currentGeoframeKey));
      if (pointTo) {
        url = `/classic/?projectUID=${projectUIDParam}&imageKey=${imageKey}&pointto=${pointTo}`;
      } else {
        url = `/classic/?projectUID=${projectUIDParam}&imageKey=${imageKey}`;
      }
    } else {
      throw new Error(
        "Unable to construct Pilegate URL: Missing baseUrl or currentGeoframeKey."
      );
    }
    return url;
  };

  //everytime that panoration change save pointTo value for generation a share link
  useEffect(() => {
    if (viewer) {
      viewer.on("panorotationchanged", function (latlonfov: JSON) {
        setPointTo(JSON.stringify(latlonfov));
      });
    }
  }, [viewer]);

  // Avatar DropDown Button Functionality
  const UserId = "User";
  return (
    <>
      <Tooltip
        title={t("tooltip.avatar")}
        placement="bottom"
        enterDelay={400}
        classes={{ tooltip: "infra3d-buttonDescription" }}
      >
        <IconButton
          size="medium"
          aria-label="User"
          aria-controls={UserId}
          aria-haspopup="true"
          onClick={(event) =>
            monitor(apm, "open-user-settings | Settings", () =>
              handleUserMenuOpen(event)
            )
          }
          color="inherit"
          id="avatarMenu"
        >
          <Avatar
            sx={{
              backgroundColor: "darkblue.main",
              "@media (hover: hover)": {
                ":hover": { backgroundColor: "secondary.main" },
              },
            }}
          >
            <Person />
          </Avatar>
        </IconButton>
      </Tooltip>
      <UserMenu
        anchorEl={anchorUser}
        UserId={UserId}
        role={role}
        handleUserClose={handleUserClose}
        redirectToClassic={redirectToClassic}
      />
    </>
  );
}
